import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import AcesCredit from './AcesCredit';
import { useAuth } from '../context/AuthContext';

const SITE_ORIGIN = 'https://vitra-health.com';
const PORTAL_ORIGIN = 'https://portal.vitra-health.com';
const isPortalHost =
  typeof window !== 'undefined' &&
  window.location.hostname.startsWith('portal.');

/** Public pages: stay on portal when logged in; marketing domain when guest / marketing site. */
function publicHref(path) {
  if (isPortalHost) return path;
  return `${SITE_ORIGIN}${path}`;
}

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { isAuthenticated } = useAuth();
  // Always use absolute marketing URL when logged out so React Router on apex
  // content pages (e.g. /privacy-policy) does not client-navigate to LoginPage at "/".
  const homeTo =
    isAuthenticated === true
      ? (isPortalHost ? '/mydashboard' : `${PORTAL_ORIGIN}/mydashboard`)
      : `${SITE_ORIGIN}/`;
  const usePortalLinks = isPortalHost && isAuthenticated === true;

  const CompanyLink = ({ to, children }) =>
    usePortalLinks ? (
      <Link to={to} className="hover:text-teal-400 transition-colors">{children}</Link>
    ) : (
      <a href={publicHref(to)} className="hover:text-teal-400 transition-colors">{children}</a>
    );

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="mb-4">
              <BrandLogo
                to={homeTo}
                variant="onDark"
                markClassName="h-8 w-8"
                wordmarkClassName="h-5"
              />
            </div>
            <p className="text-gray-400 leading-relaxed">
              Remote Patient Monitoring System for modern healthcare practices and clinicians.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-gray-100">Company</h3>
            <ul className="space-y-2 text-gray-400">
              <li><CompanyLink to="/about">About Us</CompanyLink></li>
              <li><CompanyLink to="/contact">Contact</CompanyLink></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-gray-100">Resources</h3>
            <ul className="space-y-2 text-gray-400">
              <li><button type="button" onClick={() => {}} className="hover:text-teal-400 transition-colors text-left">Documentation</button></li>
              <li><CompanyLink to="/help">Help Center</CompanyLink></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-gray-100">Legal</h3>
            <ul className="space-y-2 text-gray-400">
              <li><CompanyLink to="/privacy-policy">Privacy Policy</CompanyLink></li>
              <li><CompanyLink to="/terms">Terms of Service</CompanyLink></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} VITRA Healthcare. All rights reserved.
            </p>
            <AcesCredit variant="onDark" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
